module.exports = __webpack_public_path__ + "415945a79b41f9b46e11a7a1103f68e4.jpg";